import * as Zod from 'zod';

export const intercommodelsScheme = Zod.object({
  id: Zod.string(),
  label: Zod.string(),
});
